import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import {_ReferenceDataService} from "../../../services/referenceData.service";
import {Observable} from "rxjs/Observable";

declare var jQuery:any;
declare var $ :any;
declare var dialogCreate :any;
declare var dialogOpen :any;
declare var defaultChartExposureSettings;
declare var defaultSparklineExposureSettings;
declare var defaultGridViewSettings;

@Component({
  selector: 'acc-exp-fund',
  templateUrl: './acc-exp-fund.component.html',
  styleUrls: ['./acc-exp-fund.component.css'],
})

export class AccExpFundBranch implements OnInit, OnDestroy {

  private subscription: any;
  private accounts: any;
  private accountGroups: any;

  constructor (private titleService: Title, private referenceData: _ReferenceDataService) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Currency and Funding Exposure");

    this.subscription = Observable.forkJoin(this.referenceData.getAccounts(), this.referenceData.getAccountGroups()).subscribe((res: Array<any>) => {
      this.accounts = res[0];
      this.accountGroups = res[1];
      this.ready();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ready() {
    var accounts = this.accounts;
    var accountGroups = {};
    for(var i=0;i<this.accountGroups.length;i++){
      var accountGroup = this.accountGroups[i];
      accountGroups[accountGroup.accountGroupId] = accountGroup.displayName;
    }
    for(var i=0;i<accounts.length;i++){
      accounts[i].accountGroupDisplay = accounts[i].accountGroupId ? accountGroups[accounts[i].accountGroupId] : null;
    }

    $(document).ready(function () {
      // initialize jqxGrid
      var source = {
        datafields : [
                  { name : 'accountId' },
                  {
                    name: 'accountCode',
                    type: 'string',
                    value: 'accountId',
                    values: {
                      source: accounts,
                      value: 'accountId',
                      name: 'code'
                    }
                  },
                  {
                    name: 'accountGroupDisplay',
                    type: 'string',
                    value: 'accountId',
                    values: {
                      source: accounts,
                      value: 'accountId',
                      name: 'accountGroupDisplay'
                    }
                  },
                  { name : 'baseCurrency' },
                  { name : 'currencyPair' },
                  { name : 'targetCurrency' },
                  { name : 'counterCurrency' },
                  { name : 'counterCurrency' },
                  { name : 'totalExposurePercentage' },
                  { name : 'totalExposureQuantity' },
                  { name : 'totalExposureBaseQuantity'},
                  { name : 'targetExposurePercentage' },
                  { name : 'targetExposureQuantity' },
                  { name : 'targetExposureBaseQuantity'},
                  { name : 'executedRebalancePercentageCcy1' },
                  { name : 'executedRebalanceQuantityCcy1' },
                  { name : 'executedRebalanceBaseQuantityCcy1'},
                  { name : 'executedRebalancePercentageCcy2' },
                  { name : 'executedRebalanceQuantityCcy2' },
                  { name : 'executedRebalanceBaseQuantityCcy2'},
                  { name : 'pendingRebalancePercentageCcy1' },
                  { name : 'pendingRebalanceQuantityCcy1' },
                  { name : 'pendingRebalanceBaseQuantityCcy1'},
                  { name : 'pendingRebalancePercentageCcy2' },
                  { name : 'pendingRebalanceQuantityCcy2' },
                  { name : 'pendingRebalanceBaseQuantityCcy2'},
                ],
        url : '/ajax/funding',
        type : 'GET',
        headers:{
          Authorization: this.token
        },
        async : true
      };
      var settings = defaultGridViewSettings("#jqxExposureGrid", source);
      settings.columns = [{
//        text : 'Fund Status (%)',
//        datafield: 'fundStatus',
//        width: 200,
//        cellsalign: 'left',
//        enabletooltips: false,
//        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
//          return "<div id='jqxFundSparkLine" + row + "' style='width:100%; height:" + $('#jqxExposureGrid').jqxGrid('rowsheight') + "px'></div>" +
//              "<img src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' onload='refreshFundSparkLine(" + row + ");'>";
//        }
//      } , {
        text : 'Account',
        columntype : 'textbox',
        datafield : 'accountCode',
        width : 100
      } , {
       text : 'Account Group',
       columntype : 'textbox',
       datafield : 'accountGroupDisplay',
       width : 100
     } , {
        text : 'Target Ccy',
        columntype : 'textbox',
        datafield : 'targetCurrency',
        width : 100
      } , {
        text : 'Counter Ccy',
        columntype : 'textbox',
        datafield : 'counterCurrency',
        width : 100
      } , {
        text : 'Currency Pair',
        columntype : 'textbox',
        datafield : 'currencyPair',
        width : 100
      } , {
        text : 'Total Exposure (Target Ccy)',
        columntype : 'textbox',
        datafield : 'totalExposureQuantity',
        width : 120,
        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
          return '<div style="overflow: hidden; text-overflow: ellipsis; padding-bottom: 2px; text-align: left; margin-right: 2px; margin-left: 4px; margin-top: 4px;">' + value.format() + '</div>';
        }
      } , {
        text : 'Target Exposure (Target Ccy)',
        columntype : 'textbox',
        datafield : 'targetExposureQuantity',
        width : 120,
        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
          return '<div style="overflow: hidden; text-overflow: ellipsis; padding-bottom: 2px; text-align: left; margin-right: 2px; margin-left: 4px; margin-top: 4px;">' + value.format() + '</div>';
        }
      } , {
        text : 'Executed (Ccy1)',
        columntype : 'textbox',
        datafield : 'executedRebalanceQuantityCcy1',
        width : 100,
        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
          return '<div style="overflow: hidden; text-overflow: ellipsis; padding-bottom: 2px; text-align: left; margin-right: 2px; margin-left: 4px; margin-top: 4px;">' + value.format() + '</div>';
        }
      } , {
        text : 'Executed (Ccy2)',
        columntype : 'textbox',
        datafield : 'executedRebalanceQuantityCcy2',
        width : 100,
        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
          return '<div style="overflow: hidden; text-overflow: ellipsis; padding-bottom: 2px; text-align: left; margin-right: 2px; margin-left: 4px; margin-top: 4px;">' + value.format() + '</div>';
        }
      } , {
        text : 'Pending (Ccy1)',
        columntype : 'textbox',
        datafield : 'pendingRebalanceQuantityCcy1',
        width : 100,
        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
          return '<div style="overflow: hidden; text-overflow: ellipsis; padding-bottom: 2px; text-align: left; margin-right: 2px; margin-left: 4px; margin-top: 4px;">' + value.format() + '</div>';
        }
      } , {
        text : 'Pending (Ccy2)',
        columntype : 'textbox',
        datafield : 'pendingRebalanceQuantityCcy2',
        width : 100,
        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
          return '<div style="overflow: hidden; text-overflow: ellipsis; padding-bottom: 2px; text-align: left; margin-right: 2px; margin-left: 4px; margin-top: 4px;">' + value.format() + '</div>';
        }
      } ];
      $("#jqxExposureGrid").jqxGrid(settings);
    });

  }

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/exposure/acc-exp-fund/acc-exp-fund.component.ts